module.exports = __webpack_public_path__ + "static/media/personal-4.2ed7d748.png";